module.exports = __webpack_public_path__ + "static/maincontent-skeleton-cd5a9b19f5fdb09620bd2e1b3057d30f.jpg";